<div mat-dialog-title>Model Market Center<sup style="font-size: 7.5px">TM</sup><br>Advisor Management Fee Account Authorization
<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear" >clear</i></button>
</div>
<mat-dialog-content>
  <div style="max-height: 500px;overflow-y: auto; border: 1px solid #767676;padding: 8px;"
  [innerHTML]="agreementTxt"></div>

  <div style="margin-bottom: 10px;">
    <p-checkbox name="single" [(ngModel)]="chckBx" binary="true" (onChange)="validateState()"></p-checkbox>
    IA, by its duly authorized representative, hereby executes <b>the Authorization</b>.
  </div>

  <div>
    <span style="font-weight:bold;">Management Fee Account Number: </span>
    <input type="text" pInputText style="width: 220px;" [(ngModel)]="sundryAcct" (input)="validateState()"/>
  </div>

  @if (sundyAcctInvalid) {
    <div id="mmcSundryUADialogInvalidMessage" style="margin: 10px 0 0 0">
      <strong><span style="color: red">This management fee account is not valid. Please re-enter or contact your FSA or iRebal support team to correct your user configuration at 855-640-2472.</span></strong>
    </div>
  }

</mat-dialog-content>

<mat-dialog-actions>
  <button id="closeButton" (click)="close()" class="btn-medium-secondary">Cancel</button>
  <button id="continueButton" (click)="save()" class="btn-medium-primary" [disabled]="disableBtn">Save</button>
</mat-dialog-actions>



